<dx-select-box [items]="teamTypeConfigurations"
               displayExpr="name"
               itemTemplate="item"
               placeholder="Select a team type..."
               [readOnly]="disabled"
               [value]="teamTypeConfiguration"
               (valueChange)="teamTypeConfigurationChange.emit($event)">
    <dxo-select-box-field-addons beforeTemplate="before"></dxo-select-box-field-addons>
    <div *dxTemplate="let data of 'before'">
        <adapt-display-team-type [teamTypeConfiguration]="data"></adapt-display-team-type>
    </div>
    <div *dxTemplate="let data of 'item'"
         class="list-item">
        <adapt-display-team-type [teamTypeConfiguration]="data"
                                 [showName]="true"></adapt-display-team-type>
    </div>
</dx-select-box>
